import Permittee from "~/models/permittee";
import QuickLinkFolder from "~/models/dashboards/dashboard";

export default class QuickLinkFolderAssignment extends Permittee<QuickLinkFolder> {
  reference_helpers: {name: string, first_name: string, last_name: string, email: string, activation_status: number, role_type: string, display: boolean}

  get classKey(): string {
    return "QuickLinkFolderAssignment";
  }

  get UNTRACKED_PROPERTIES(): string[] {
    return ["role_type", "display"];
  }
}